import type { Answer, MatchResult, PersistedState } from '../types';

export const STORAGE_KEY = 'gaishi-hero-h5:v1';
export const ACTIVATION_CODE = 'H7X9-K3R8-P6M2-V5Q4';

export const emptyState = (): PersistedState => ({
  version: 1,
  activated: false,
  currentIndex: 0,
  answers: Array.from({ length: 28 }, () => null),
  result: null,
});

function isAnswer(value: unknown): value is Answer | null {
  return value === null || value === 'A' || value === 'B' || value === 'C' || value === 'D';
}

export function loadState(): PersistedState {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null') as Partial<PersistedState> | null;
    if (!parsed || parsed.version !== 1 || !Array.isArray(parsed.answers) || parsed.answers.length !== 28 || !parsed.answers.every(isAnswer)) return emptyState();
    return {
      version: 1,
      activated: Boolean(parsed.activated),
      currentIndex: Math.min(27, Math.max(0, Number(parsed.currentIndex) || 0)),
      answers: parsed.answers,
      result: parsed.result ?? null,
    };
  } catch {
    return emptyState();
  }
}

export function saveState(state: PersistedState) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function updateAnswer(state: PersistedState, index: number, answer: Answer): PersistedState {
  const answers = [...state.answers];
  answers[index] = answer;
  return { ...state, answers, currentIndex: index, result: null };
}

export function withResult(state: PersistedState, result: MatchResult): PersistedState {
  return { ...state, result };
}

export function restartQuiz(state: PersistedState): PersistedState {
  return { ...emptyState(), activated: state.activated };
}
